import React from 'react';

import { usePathname } from 'expo-router';

import { MenuProduct } from './menu-product-v2';
import { useMenuObjPageStatusBarForAndroid } from './use-menu-obj-page-status-bar-for-android';

// old - not one menu
export const MenuObjectPage = () => {
  const pathname = usePathname();
  useMenuObjPageStatusBarForAndroid(pathname);

  return <MenuProduct />;
};
